/**
 * @file: linking.presentation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { rewriteAuthedPath } from '@euler/app/navigation/rewriteAuthedPath';
import { LinkingConfiguration } from '@euler/app/navigation/types';
import { linkingFactory } from '@euler/lib/linking';

// the linking configuration defines how to map state to paths and vice versa.
export const linking: LinkingConfiguration = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  normal: linkingFactory<{}>(
    {
      screens: {
        Home: {
          screens: {
            Dashboard: {
              path: '',
              exact: true,
            },
          },
        } as any,
        ApdmCampaignWizard: {
          path: 'apdm/campaigns/wizard/:campaignId?',
          exact: true,
        },
        Task: {
          screens: {
            TaskDetail: {
              path: 'tasks/:taskNo',
              exact: true,
            },
          },
        },
        NotFound: '*',
      },
      // ensure home will always be the first route
    },
    { rewritePath: rewriteAuthedPath },
  ),
  // eslint-disable-next-line @typescript-eslint/ban-types
  auth: linkingFactory<{}>({
    screens: {
      Auth: {
        path: '',
        screens: {
          Login: 'login',
        },
      },
    },
  }),
};
